// (function ($) {

//   if (window.matchMedia("(min-width: 767px)").matches) {
//   } else {
//     var scrollend = $('.post-single--tours-cat-field .right-box').offset().top; //ページ上部からの距離を取得
//     var distance = 0;
//     $(document).scroll(function () {
//       distance = $(this).scrollTop(); //スクロールした距離を取得
//       if ((scrollend) <= distance) {
//         $('.post-single--tours-cat-field .right-box .float-btn').removeClass("fade_on");
//       } else {
//         $('.post-single--tours-cat-field .right-box .float-btn').addClass("fade_on");
//       }
//     });
//   }

// })(jQuery);


(function ($) {
  if (window.matchMedia("(min-width: 1024px)").matches) {
  } else {
    $(document).ready(function () {
      let pagetop_bnr = '.post-single--tours-cat-field .right-box .float-btn';
      let footer_bnt = 'footer';

      $(pagetop_bnr).hide();
      $(footer_bnt).css('position', 'relative');

      $(window).on("scroll", function () {
        if ($(this).scrollTop() > 500) {
          $(pagetop_bnr).slideDown("fast");
        } else {
          $(pagetop_bnr).slideUp("fast");
        }
        let bnr_scrollHeight = $(document).height();
        let bnr_scrollPosition = $(window).height() + $(window).scrollTop();
        let bnr_footHeight = $(footer_bnt).innerHeight();
        // console.log(bnr_footHeight);
        if (bnr_scrollHeight - bnr_scrollPosition <= bnr_footHeight) {
          $(pagetop_bnr).css({//フッターに到達したら
            "position": "absolute",
            "opacity": "0"
          });
        } else { //フッターに到達する前
          $(pagetop_bnr).css({
            "position": "fixed",
            "bottom": "0px",
            "opacity": "1"
          });
        }
      });
      $(pagetop_bnr).on('click', function () {
        $('body,html').animate({
          scrollTop: 0
        }, 400);
        return false;
      });
    });
  }

  //ツアーのシングルページだけ二重書き
  $(document).ready(function () {
    let pagetop = '#pagetop';
    let footer = 'footer';

    $(pagetop).hide();
    $(footer).css('position', 'relative');

    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 500) {
        $(pagetop).slideDown("fast");
      } else {
        $(pagetop).slideUp("fast");
      }
      let bnr_scrollHeight = $(document).height();
      let bnr_scrollPosition = $(window).height() + $(window).scrollTop();
      let bnr_footHeight = $(footer).innerHeight();
      // console.log(bnr_footHeight);
      if (bnr_scrollHeight - bnr_scrollPosition <= bnr_footHeight) {
        $(pagetop).css({//フッターに到達したら
          "position": "absolute",
          "bottom": bnr_footHeight - 24
        });
      } else { //フッターに到達する前
        $(pagetop).css({
          "position": "fixed",
          "bottom": "20px"
        });
      }
    });
    $(pagetop).on('click', function () {
      $('body,html').animate({
        scrollTop: 0
      }, 400);
      return false;
    });
  });
})(jQuery);
